import { SiteConfigManager } from '@atlas/core';
import { clientProfileRoutes, paymentRoutes, staticRoutes } from '@atlas/routing';

import { ACCOUNT_STATUSES } from 'src/common/constants';

export const getDepositLink = (account, clientProfilePath) => {
  const showInPopup = SiteConfigManager.getConfig('config.config.registration.showInPopup', false);
  const isPartiallyRegistered = account.status === ACCOUNT_STATUSES.PARTIALLY_REGISTERED;

  if (isPartiallyRegistered) {
    return showInPopup ? '?cmd=signup' : staticRoutes.signup;
  }

  return `${clientProfilePath}/${clientProfileRoutes.payment}/${paymentRoutes.deposit}`;
};
